import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

import { CPermission } from "src/1/common/components/others";
import { ChevronDown, ChevronUp } from "src/common/assets/icons";

import { CNavItem } from "./CNavItem";
import { CPopoverMenu } from "./CPopoverMenu";

export const CNavList = ({ data, sidebarOpen }) => {
  //#region Data
  const [open, setOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const location = useLocation();

  const isSelected = useMemo(
    () => location?.pathname?.startsWith(data?.route),
    [location, data?.route],
  );

  const parentRef = useRef(null);
  const isInsidePopover = useRef(false);
  //#endregion

  //#region Event
  const toggle = () => setOpen(!open);

  const onMouseEnter = () => {
    if (sidebarOpen) return;
    setPopoverOpen(true);
  };

  const onMouseLeave = (event) => {
    if (!isInsidePopover.current) {
      setPopoverOpen(false);
    }
  };

  const onMoveToPopover = () => {
    isInsidePopover.current = true;
  };

  const closePopover = () => {
    isInsidePopover.current = false;
    setPopoverOpen(false);
  };
  //#endregion

  useEffect(() => {
    if (sidebarOpen === false) setOpen(false);
  }, [sidebarOpen]);

  //#region Render
  return (
    <li
      className="overflow-hidden"
      ref={parentRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        onClick={sidebarOpen === false ? undefined : toggle}
        className={classNames(
          "flex flex-row gap-4 items-center text-[#053C7F] !py-3 !px-4 text-base font-medium overflow-hidden hover:bg-[#c9ddfe] cursor-pointer",
          isSelected && "nav-selected bg-blue-200 hover:bg-blue-200",
        )}
      >
        <div className="sidebar-icon h-6 w-6 shrink-0 flex items-center justify-center">
          {data.icon}
        </div>
        <span className="whitespace-nowrap flex-1 select-none">
          {data.name}
        </span>
        <div className="shrink-0">{open ? <ChevronUp /> : <ChevronDown />}</div>
      </div>
      <div
        className={classNames(
          "text-black transition-all duration-300 origin-top",
          open ? "max-h-[1000px]" : "max-h-0",
        )}
      >
        {data?._children?.map((e, i) => (
          <CPermission key={e?.name + e?.to} permissions={e.permissions}>
            <CNavItem data={e} />
          </CPermission>
        ))}
      </div>
      <CPopoverMenu
        open={popoverOpen}
        data={data}
        onMoveToPopover={onMoveToPopover}
        closePopover={closePopover}
      />
    </li>
  );
  //#endregion
};
